import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod'

const registerSearchSchema = z.object({
  error: z.string().optional(),
  user_code: z.string().optional(),
  redirectPage: z.string().optional(),
  redirectUrl: z.string().optional(),
})

export const Route = createFileRoute('/register/')({
  validateSearch: (search) => registerSearchSchema.parse(search),
  // Sign-up moved to MotherDuck after the acquisition. Anything still pointing at
  // /register (docs, old links, bookmarks) lands on the explanation page instead.
  beforeLoad: () => {
    throw redirect({ to: '/registration-closed', replace: true })
  },
})
